/* eslint-disable camelcase */
/* eslint-disable prefer-rest-params */

import React from "react";
import moment from "moment";
// Internals Imports
import { AUTH, SETTINGS } from "../constants";

// Destructuring
const { PRODUCTION } = AUTH;
const { FREE_TRAIL } = SETTINGS;

export const injectInlineManual = (user, userSignUpInfo) => {
  if (
    !window.inlineManualTracking &&
    userSignUpInfo &&
    Object.keys(userSignUpInfo).length > 0 &&
    user.billing_plan === FREE_TRAIL
  ) {
    const roles = user.roles.map(role => role.name);
    window.inlineManualTracking = {
      created: Math.floor(new Date(user.created_at) / 1000),
      email: user.user_email,
      group: userSignUpInfo.group,
      interest_level: userSignUpInfo.interest_level,
      name: `${user.first_name} ${user.last_name}`,
      org_user_count: userSignUpInfo.uc,
      organisation: user.organisation,
      plan: user.billing_plan,
      problem: userSignUpInfo.problem,
      roles,
      uid: user.id,
      updated: Math.floor(new Date(user.created_at) / 1000),
      username: user.username,
      utm_keywords: userSignUpInfo.utm_term,
    };
    window.inlineManualOptions = {
      variables: {
        name: user.first_name,
        organisation: window.inlineManualTracking.organisation,
      },
    };

    let retries = 0;
    const timer = setInterval(() => {
      if (typeof window.createInlineManualPlayer !== "undefined") {
        // eslint-disable-next-line no-undef
        createInlineManualPlayer(window.inlineManualPlayerData);
        clearInterval(timer);
      } else if (retries > 100) {
        clearInterval(timer);
      }
      retries += 1;
    }, 50);
  }
};

// export const injectFreshChat = (user, userSignUpInfo) => {
//   const roles = user.roles.map(role => role.name);
//   const envName = process.env.REACT_APP_ENVIRONMENT;
//   if (
//     !window.fcWidget &&
//     user &&
//     (envName === HURRICANE || envName === PRODUCTION)
//   ) {
//     const initFreshChat = () => {
//       window.fcWidget.init({
//         token: "380bf74a-82c4-4c3f-86eb-f5e6042a9e1f",
//         host: "https://wchat.freshchat.com",
//         tags: ["public", "signedin", "outbound"],
//       });

//       // To set unique user id in your system when it is available
//       window.fcWidget.setExternalId(user.id);

//       // To set user name
//       window.fcWidget.user.setFirstName(user.first_name);

//       // To set user email
//       window.fcWidget.user.setEmail(user.user_email);

//       // To set user properties
//       window.fcWidget.user.setProperties({
//         Organisation: user.organisation,
//         Teammates: userSignUpInfo.uc,
//         Role: roles.toString(),
//         Plan: user.billing_plan,
//       });
//     };
//     const initialize = (i, t) => {
//       let e;
//       // eslint-disable-next-line no-unused-expressions
//       i.getElementById(t)
//         ? initFreshChat()
//         : (((e = i.createElement("script")).id = t),
//           (e.async = !0),
//           (e.src = "https://wchat.freshchat.com/js/widget.js"),
//           (e.onload = initFreshChat),
//           i.head.appendChild(e));
//     };
//     initialize(document, "freshchat-js-sdk");
//   }
// };

export const injectCustomerIO = user => {
  const envName = process.env.REACT_APP_ENVIRONMENT;
  if (
    envName &&
    envName === PRODUCTION &&
    user &&
    !window.revv_cio_integration
  ) {
    const initCio = () => {
      let c;
      const a = function(f) {
        return function() {
          // eslint-disable-next-line no-undef
          _cio.push([f].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      const b = ["load", "identify", "sidentify", "track", "page"];
      for (c = 0; c < b.length; c += 1) {
        // eslint-disable-next-line no-undef
        _cio[b[c]] = a(b[c]);
      }
      const t = document.createElement("script");
      const s = document.getElementsByTagName("script")[0];
      t.async = true;
      t.id = "cio-tracker";
      t.setAttribute("data-site-id", "e1b58a1c9f4686e23e93");
      t.src = "https://assets.customer.io/assets/track.js";
      s.parentNode.insertBefore(t, s);
    };
    initCio();
    const {
      user_oid: id,
      user_email: email,
      created_at,
      first_name,
      last_name,
      billing_plan,
    } = user;
    // eslint-disable-next-line no-undef
    _cio.identify({
      // Required attributes
      id, // Unique id for the currently signed in user in your application.

      // Strongly recommended attributes
      email, // Email of the currently signed in user.
      created_at: moment(created_at).valueOf() / 1000, // Timestamp in your system that represents when
      // the user first signed up. You'll want to send it
      // as seconds since the epoch.

      // Example attributes (you can name attributes what you wish)
      first_name, // Add any attributes you'd like to use in the email subject or body.
      last_name, // First name and last name are shown on people pages.
      plan_name: billing_plan, // To use the example segments, set this to 'free' or 'premium'.
    });
    window.revv_cio_integration = true;
  }
};

export const injectDriftChatNonLoggedIn = (Component, props) => (
  // const envName = process.env.REACT_APP_ENVIRONMENT;
  // if (
  //   envName &&
  //   // remove MOJITO later if not required
  //   (envName === HURRICANE || envName === PRODUCTION || envName === MOJITO)
  // ) {
  //   return (
  //     <Fragment>
  //       <Component {...props} />
  //       <Drift appId={process.env.REACT_APP_DRIFT_APPID} />
  //     </Fragment>
  //   );
  // }
  <Component {...props} />
);

export const injectDriftChat = (Component, props) => (
  // const envName = process.env.REACT_APP_ENVIRONMENT;
  // const user = readDataFromLocalStorage("revvsalesUser");
  // if (
  //   envName &&
  //   // remove MOJITO later if not required
  //   (envName === HURRICANE || envName === PRODUCTION || envName === MOJITO) &&
  //   user
  // ) {
  //   const {
  //     user_oid: uid,
  //     user_email: email,
  //     first_name: firstName,
  //     last_name: lastName,
  //     organisation,
  //     billing_plan: plan,
  //     roles,
  //   } = user;
  //   return (
  //     <Fragment>
  //       <Component {...props} />
  //       <Drift
  //         appId={process.env.REACT_APP_DRIFT_APPID}
  //         userId={uid}
  //         attributes={{
  //           name: `${firstName} ${lastName}`,
  //           email,
  //           organisation,
  //           plan,
  //           roles: roles ? roles.map(role => role.name) : [],
  //         }}
  //       />
  //     </Fragment>
  //   );
  // }
  <Component {...props} />
);



// WEBPACK FOOTER //
// ./src/app/methods.js